import { IIconProps } from './add';

export const IcoEllipse: React.FC<IIconProps> = ({ cy, style }) => (
  <svg
    width="4"
    height="4"
    viewBox="0 0 4 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-cy={`IcoEllipse${cy}`}
    style={style}
  >
    <circle cx="2" cy="2" r="2" fill="#BBC1C9" />
  </svg>
);
